import type { FunctionComponent } from 'react'
import { createElement, Suspense } from 'react'
import type { RouteObject } from 'react-router-dom'
import { Navigate } from 'react-router-dom'
import { PageLoading } from '../content/pages/helpers/PageLoading'
import { Pages, PagesEnum, PagesNames } from '../content/pages/pages'
import { urlService } from '../content/services/url.service'
import { PageWrapper } from './PageWrapper'

// eslint-disable-next-line complexity -- to be refactored at a later time
export const getRoutes = (overridePageComponent?: { pageKey: PagesEnum; component: FunctionComponent }) => {
    const routes: RouteObject[] = []
    for (const page of PagesNames(true)) {
        const overrideElement = page === overridePageComponent?.pageKey ? overridePageComponent.component : undefined

        /*
         * The "urls" property is undefined if a react router page does not have a corresponding umbraco page setup.
         * */
        if (Pages[page].urls && Pages[page].urls.length) {
            const pageRoute: RouteObject = {
                element: <PageWrapper page={page as PagesEnum} overrideElement={overrideElement} />,
            }

            let hasSubPages = false
            if (Pages[page].subPages && Pages[page].subPages.length > 0) {
                hasSubPages = true
                pageRoute.children = []
                for (const subPage of Pages[page].subPages) {
                    const overrideSubPageComponent =
                        subPage === overridePageComponent?.pageKey ? overridePageComponent?.component : undefined

                    if (subPage?.urls?.length) {
                        pageRoute.children.push({
                            element: (
                                <Suspense fallback={<PageLoading />}>
                                    {createElement(overrideSubPageComponent ?? subPage.component)}
                                </Suspense>
                            ),
                            path: urlService.lastUrlSegment(subPage.urls[0]),
                        })
                    }
                }

                // When no subpage was found, go to first one
                pageRoute.children.push({
                    element: <Navigate to={Pages[page].subPages[0].urls[0] ?? '/'} />,
                    path: '*',
                })
            }

            for (const url of Pages[page].urls) {
                routes.push({ ...pageRoute, path: url + (hasSubPages ? '/*' : '') })
            }
        }
    }

    // Not found routes work as you'd expect
    routes.push({
        path: '*',
        element: <PageWrapper page={PagesEnum.ErrorNotFound} />,
    })

    return routes
}
